export default __webpack_public_path__ + "static/media/Content1.967e99d2.svg";